import {
  FETCH_TOP_ASHA_DATA,
  FETCH_TOP_ASHA_DATA_SUCCESS,
  FETCH_TOP_ASHA_DATA_FAILURE,
  FETCH_ASHA_PROFILE,
  FETCH_ASHA_PROFILE_SUCCESS,
  FETCH_ASHA_PROFILE_ERROR,
  FETCH_ASHA_SCHEMES,
  FETCH_ASHA_SCHEMES_SUCCESS,
  FETCH_ASHA_SCHEMES_ERROR,
  SEND_REMINDER,
  SEND_REMINDER_SUCCESS,
  SEND_REMINDER_FAILURE,
  FETCH_ASHAS_ON_INCENTIVES,
  FETCH_ASHAS_ON_INCENTIVES_SUCCESS,
  FETCH_ASHAS_ON_INCENTIVES_FAILURE,
  FETCH_INCENTIVE_DETAILS_SUCCESS,
  NO_RECORDS_FOUND_ACTION,
  FETCH_TOTAL_ASHA_ANM_DATA,
  FETCH_TOTAL_ASHA_ANM_DATA_SUCCESS,
  FETCH_TOTAL_ASHA_ANM_DATA_FAILURE,
  FETCH_ACTIVE_INACTIVE_CARD_DATA_COUNT,
  FETCH_ACTIVE_INACTIVE_CARD_DATA_COUNT_SUCCESS,
  FETCH_ACTIVE_INACTIVE_CARD_DATA_COUNT_FAILURE,
  FETCH_ASHA_BY_REGION_TABLE,
  FETCH_ASHA_BY_REGION_TABLE_SUCCESS,
  FETCH_ASHA_BY_REGION_TABLE_FAILURE

} from './AshaAnmSectionActions';
const defaultState = {
  topPerformerData: [],
  isLoading: false,
  ashaProfile: {},
  ashaSchemes: {},
  ashasOnIncentives: [],
  incentiveData: [],
  totalAshaAnmTableList: [],
  ashasInAnm :[],
  areaType: '',
  ashaList:[],
  activeInactiveCount: null,
};

const AshaAnmSectionReducer = (state = defaultState , action) => {
  switch (action.type) {
    case FETCH_TOP_ASHA_DATA:
      return { ...state, isLoading: true };
    case FETCH_TOP_ASHA_DATA_SUCCESS:
      return { ...state, isLoading: false, topPerformerData: action.payload };
    case FETCH_TOP_ASHA_DATA_FAILURE:
      return { ...state, isLoading: false };
    case FETCH_ASHA_PROFILE:
    case FETCH_ASHA_PROFILE_ERROR:
      return { ...state };
    case FETCH_ASHA_PROFILE_SUCCESS:
      return { ...state, ashaProfile: action.payload };
    case FETCH_ASHA_SCHEMES: // Handle the FETCH_ASHA_SCHEMES action
      return { ...state, isLoading: true };
    case FETCH_ASHA_SCHEMES_SUCCESS: // Handle the FETCH_ASHA_SCHEMES_SUCCESS action
      return { ...state, isLoading: false, ashaSchemes: action.payload };
    case FETCH_ASHA_SCHEMES_ERROR:
      return { ...state, isLoading: false, ashaSchemes: {} };
    case FETCH_ASHAS_ON_INCENTIVES:
      return { ...state, isLoading: true };
    case FETCH_ASHAS_ON_INCENTIVES_SUCCESS:
      return { ...state, isLoading: false, ashasOnIncentives: action.payload };
    case FETCH_ASHAS_ON_INCENTIVES_FAILURE:
      return { ...state, isLoading: false, ashasOnIncentives: [] };
    case NO_RECORDS_FOUND_ACTION:
      return { ...state, incentiveData: action.payload };
    case FETCH_INCENTIVE_DETAILS_SUCCESS:
      return { ...state, incentiveData: action.payload };
      case FETCH_ASHA_BY_REGION_TABLE:
            return { ...state, isLoading: true };
          case FETCH_ASHA_BY_REGION_TABLE_SUCCESS:
            return { ...state, isLoading: false, ashaList: action.payload };
          case FETCH_ASHA_BY_REGION_TABLE_FAILURE :
            return { ...state, isLoading: false,ashaList: [] };
    case SEND_REMINDER:
    case SEND_REMINDER_SUCCESS:
    case SEND_REMINDER_FAILURE:
      return { ...state };

    case FETCH_TOTAL_ASHA_ANM_DATA:
      return { ...state, isLoading: true, paginationData: {} }; 
    case FETCH_TOTAL_ASHA_ANM_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        totalAshaAnmTableList: action.payload, paginationData: action.paginationData,
      };
    case FETCH_TOTAL_ASHA_ANM_DATA_FAILURE:
      return { ...state, isLoading: false, paginationData: {} };
    case FETCH_ACTIVE_INACTIVE_CARD_DATA_COUNT:
      return { ...state, isLoading: true };
    case FETCH_ACTIVE_INACTIVE_CARD_DATA_COUNT_SUCCESS:
      return { ...state, isLoading: false, activeInactiveCount: action.payload.data };
    case FETCH_ACTIVE_INACTIVE_CARD_DATA_COUNT_FAILURE:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};
export default AshaAnmSectionReducer;
